// extracted by mini-css-extract-plugin
export default {"container":"Car3DView_container__yJrdv","loadingOverlay":"Car3DView_loadingOverlay__aouNy"};